import { toaster } from 'evergreen-ui';
import React from 'react';
import {
  Navigate, Route, Routes, useParams,
} from 'react-router-dom';
import { isInt } from 'Utils/primitives';
import ReportForm from 'Features/Reports/Report.Form';
import { useGetReportsListQuery } from 'Services/api/reportsApi';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { TableWrapper } from './Report.Data.Main';
import { ReportContext } from './Report.Context';

export default function ReportRouteCheck() {
  const {
    setReportName, setGroups, setSelectedReportId, setIsFixedSettings, setCalcModuleParams, setDate, setPageSize,
  } = React.useContext(ReportContext);
  const { reportId } = useParams();
  const { element: report, isFetching: reportsIsFetching, isSuccess: reportsIsSuccess } = useGetReportsListQuery()
    .getById(reportId);

  React.useEffect(() => {
    if (!reportsIsFetching && reportsIsSuccess && isInt(reportId) && !report) toaster.warning(`Отчета №${reportId} нет, либо нет прав доступа`);
  }, [report, reportId, reportsIsSuccess, reportsIsFetching]);

  React.useEffect(() => {
    if (report) {

      setSelectedReportId(report.id);
      setReportName(report.name);
      setGroups(report.report.groups);
      setIsFixedSettings(report.report.isFixedSettings);
      setCalcModuleParams(Object.keys(report.report.calcModuleParams).includes('factData') ? report.report.calcModuleParams : { ...report.report.calcModuleParams, factData: false });
      if (report.report.isFixedSettings) {
        setDate(report.report.date);
        setPageSize(report.report.pageSize);
      }
    }
  }, [report, setCalcModuleParams, setDate, setGroups, setIsFixedSettings, setPageSize, setReportName, setSelectedReportId]);

  if (reportsIsFetching) return <SuspenseSpinner />;
  if (!isInt(reportId)) return <Navigate to=".." />;
  if (reportsIsSuccess && !report) return <Navigate to=".." />;
  return (
    <Routes>
      <Route path="/*" element={<TableWrapper />} />
      <Route path="edit" element={<ReportForm />} />
    </Routes>
  );
}
